module.exports = __webpack_public_path__ + "public/images/curated-hero-section-squiggle.2ad5d6313d99fbc568a45aff157575cf.svg";